import { render } from "./settings_roles.vue?vue&type=template&id=4ae9f20c"
import script from "./settings_roles.vue?vue&type=script&lang=js"
export * from "./settings_roles.vue?vue&type=script&lang=js"
script.render = render

export default script